module.exports = __webpack_public_path__ + "media/images/categories/color/resturant-4193a1f797fe0e5f1377e6be66ab5be6.png";